// extracted by mini-css-extract-plugin
export default {"productChoiceContainer":"ProductChoice-productChoiceContainer_pN4h3"};